export enum GamificationType {
    NONE = "None",
    POINTS = "Points",
    BADGES = "Badges",
}